import { renderToStaticMarkup } from "react-dom/server";
import html2pdf from "html2pdf.js";

import { buildSOPViewCompletedActionJSX } from "./SOPViewCompletedJSX";

import conxtdOut from "apis/conxtdOut";
import axios from "axios";

const toDataUrl = async (url) => {
  return new Promise((resolve) => {
    axios({
      method: 'get',
      url: url,
      responseType: 'blob'
    }).then((response) => {
      var reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(response.data);
    }).catch((error) => {
      console.log("Unable to retrieve camera image: " + error.message);
      resolve(null);
    });
  });
};

const createExport = (
  row,
  assignedUser,
  eventIcon,
  label,
  colour,
  time,
  area,
  zone,
  contactStatus,
  cameraImageData,
  steps
) => {
  const JSXContent = buildSOPViewCompletedActionJSX(
    row,
    assignedUser,
    eventIcon,
    label,
    colour,
    time,
    area,
    zone,
    contactStatus,
    cameraImageData,
    steps
  );

  if (JSXContent) {
    const HTMLContent = renderToStaticMarkup(JSXContent);

    const fileName = `${row.site_name} - ${label} - ${time.format("DD MMM YYYY")} - SOP.pdf`;

    var options = {
      margin: 0.75,
      filename: fileName,
      // image: { type: 'jpeg', quality: 0.98 },
      image: { type: 'jpeg' },
      // html2canvas: { scale: 2 },
      pagebreak: { avoid: '.avoid-page-break' },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
    };

    html2pdf(HTMLContent, options);
  }
}

export const sopViewCompletedExportToPdf = async (
  enterpriseId,
  groupId,
  row,
  assignedUser,
  eventIcon,
  label,
  colour,
  time,
  area,
  zone,
  contactStatus,
  cameraEvents,
  steps
) => {
  if (cameraEvents && cameraEvents.length > 0) {
    // get the data fresh from the endpoint, because we need a fresh presigned url to access the image from s3
    const refreshSOP = await conxtdOut.get(`/sop/sop-action-maps/action-map/${enterpriseId}/${groupId}/${row.sudo_state[0].id}/${row.id}/${row.sop_action_map_id}`);

    const cameraImageUrl = refreshSOP.data.camera_events && (refreshSOP.data.camera_events.length > 0) && refreshSOP.data.camera_events[0].clip_url;

    // get the image data
    const cameraImageData = await toDataUrl(cameraImageUrl);

    createExport(
      row,
      assignedUser,
      eventIcon,
      label,
      colour,
      time,
      area,
      zone,
      contactStatus,
      cameraImageData,
      steps
    )
  } else {
    createExport(
      row,
      assignedUser,
      eventIcon,
      label,
      colour,
      time,
      area,
      zone,
      contactStatus,
      null,
      steps
    )
  }
}